import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'hk-layout-container',
  template: `
    <div
      #scrollableDiv
      (scroll)="onScrollEvent()"
      class="absolute flex h-full w-full flex-1"
      [class.overflow-auto]="scrollable"
      [class.overflow-hidden]="!scrollable"
    >
      <ng-content></ng-content>
    </div>
  `,
  host: { class: 'flex flex-1 relative' },
  standalone: true,
})
export class LayoutContainerComponent {
  @Input() scrollable = false;
  @Output() scrollEvent = new EventEmitter<boolean>();
  @ViewChild('scrollableDiv') scrollableDivRef: ElementRef | undefined;

  onScrollEvent() {
    this.scrollEvent.emit(this.scrollableDivRef?.nativeElement.scrollTop !== 0);
  }
}
